import React, { Component } from "react";
import ReactDOM from "react-dom";

import "./index.scss";

interface ModalProps {
  className?: string;
  title?: string;
  width: number;
  height?: number;
  onClose: () => void;
  children: React.ReactNode;
}

class Modal extends Component<ModalProps> {
  wrapperRef: React.RefObject<HTMLDivElement | null>;

  constructor(props: ModalProps) {
    super(props);

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    window.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    window.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown(e: KeyboardEvent) {
    if (e.keyCode === 27) {
      this.props.onClose();
    }
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event: MouseEvent) {
    if (
      this.wrapperRef.current &&
      !this.wrapperRef.current.contains(event.target as Node)
    ) {
      this.props.onClose();
    }
  }

  render() {
    const { title, className } = this.props;

    const modalStyles = {
      height: this.props.height,
      width: this.props.width,
    };

    const hasTitle = title && title.length;

    const modalNode = (
      <div
        className={`component common-modal ${
          hasTitle ? "with-title" : "without-title"
        } ${className ? className : ""}`}
        style={modalStyles}
        ref={this.wrapperRef}
      >
        {hasTitle && (
          <div className="modal-header">
            <div className="modal-header-inner-wrapper">{title}</div>
          </div>
        )}
        <div className="modal-body">{this.props.children}</div>
      </div>
    );

    const getModalContainerNode = () => {
      const modalContainerNode = document.querySelector(
        "body > div#modal-container-node"
      );
      if (modalContainerNode !== null) {
        return modalContainerNode;
      } else {
        const modalContainerNode = document.createElement("div");
        modalContainerNode.id = "modal-container-node";
        return document.body.appendChild(modalContainerNode);
      }
    };

    return ReactDOM.createPortal(modalNode, getModalContainerNode());
  }
}

export default Modal;
